import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { LocationStrategy, HashLocationStrategy } from '@angular/common';
import { LOCALE_ID } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { PortalLayoutComponent } from './layouts/portal-layout/portal-layout.component';
import { JwtInterceptor } from './core/interceptors/jwt.interceptor';
import { GlobalAlertComponent } from './shared/components/global-alert/global-alert.component';
import { SidenavComponent } from './shared/components/sidenav/sidenav.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeng/themes/lara';

@NgModule({ declarations: [
        AppComponent,
        PortalLayoutComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        NgxSpinnerModule,
        GlobalAlertComponent,
        SidenavComponent], providers: [
        { provide: LOCALE_ID, useValue: 'es-ES' },
        { provide: LocationStrategy, useClass: HashLocationStrategy },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: JwtInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: Lara,
                options: {
                    darkModeSelector: '.dark'
                }
            }
        })
    ] })
export class AppModule { }
